import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/694b028cb25d571e2fe0477f_AGS_4689%203.png"
          alt="Professional Security Services"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-dark-900/70 via-dark-900/50 to-dark-900/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <div className="mb-6">
          <span className="inline-block px-4 py-2 bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 rounded-full text-primary-300 text-sm font-medium">
            SAFETY Act Certified
          </span>
        </div>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 font-display">
          Professional Security Services<br />You Can Trust
        </h1>
        <p className="text-xl md:text-2xl text-dark-100 mb-8 max-w-3xl mx-auto">
          Armed & Unarmed Security, Patrols, Event & Loss Prevention Services
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/contact"
            className="px-8 py-4 bg-primary-500 text-dark-900 rounded-lg text-base font-semibold hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap inline-flex items-center cursor-pointer"
          >
            Request a Consultation
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/services"
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-lg text-base font-semibold hover:bg-white/20 transition-all whitespace-nowrap inline-flex items-center cursor-pointer"
          >
            View Services
            <i className="ri-shield-check-line ml-2"></i>
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-6">
            <div className="text-4xl font-bold text-primary-400 mb-2">28+</div>
            <div className="text-white text-sm">Years of Experience</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-6">
            <div className="text-4xl font-bold text-primary-400 mb-2">33</div>
            <div className="text-white text-sm">States Served</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-6">
            <div className="text-4xl font-bold text-primary-400 mb-2">24/7</div>
            <div className="text-white text-sm">Protection Available</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;